import React from 'react'
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Text, Box } from '@chakra-ui/react'
import { tableStyles } from '../styles/tableStyles'

interface SentimentsTableProps {
  data: any[][] | null
}

const SentimentsTable: React.FC<SentimentsTableProps> = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <Text>No data available or data is not in expected format.</Text>
  }

  const headers = data[0]
  const rows = data.slice(1)

  return (
    <Box sx={tableStyles.container}>
      <TableContainer sx={tableStyles.tableContainer}>
        <Table variant="simple" size="sm" colorScheme="blue" sx={tableStyles.table}>
          <Thead>
            <Tr>
              {headers.map((header, index) => (
                <Th 
                  key={index}
                  sx={tableStyles.headerCell}
                  title={header}
                >
                  {header}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((row, rowIndex) => (
              <Tr 
                key={rowIndex}
                role="group"
                sx={tableStyles.row}
              >
                {row.map((cell, cellIndex) => (
                  <Td 
                    key={cellIndex}
                    sx={tableStyles.cell}
                    title={cell}
                  >
                    {cell}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default SentimentsTable
